import clsx from 'clsx';
import { Draggable } from '@hello-pangea/dnd';
import type { AgentApiJobChangeProcessesRecord } from '@/types/serializers';

type Props = {
  jobChangeProcess: AgentApiJobChangeProcessesRecord;
  index: number;
  isSelected: boolean;
  onSelect: (jobChangeProcess: AgentApiJobChangeProcessesRecord) => void;
};

export default function JobChangeProcessBoardCard({
  jobChangeProcess,
  index,
  isSelected,
  onSelect,
}: Props) {
  const assignees = jobChangeProcess.candidate_profile?.organization_users ?? [];

  return (
    <Draggable draggableId={String(jobChangeProcess.id)} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          onClick={() => onSelect(jobChangeProcess)}
          className={clsx(
            'flex cursor-pointer flex-col justify-center gap-xs rounded-sm bg-white p-md drop-shadow-[0px_0px_3px_var(--color-shadow)]',
            snapshot.isDragging && 'bg-gray_darken!',
            isSelected && 'bg-gray-50'
          )}
          style={{ ...provided.draggableProps.style }}
        >
          <div className="flex flex-col gap-0.5">
            <p className="line-clamp-1 text-heading-xxs text-main">
              {jobChangeProcess.candidate_profile?.name}
            </p>
            <p className="line-clamp-1 text-heading-xxs text-main">
              {jobChangeProcess.company?.name}
            </p>
          </div>
          <div className="min-h-[0.5px] w-full bg-border"></div>
          <div className="flex flex-col items-start gap-xxs">
            {assignees[0] && (
              <span className="flex h-5 items-center justify-center gap-xxs rounded-full border border-solid border-border bg-white px-sm text-tag-sm whitespace-pre text-main">
                {assignees[0].name}
                {assignees.length > 1 && (
                  <span className="text-primary">+{assignees.length - 1}</span>
                )}
              </span>
            )}
            <span className="flex h-5 items-center rounded-full bg-tag-gray px-sm text-body-xs text-tag-gray">
              {jobChangeProcess.progress_name}
            </span>
          </div>
        </div>
      )}
    </Draggable>
  );
}
